import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "mb-x1 o-text-h3"
}
const _hoisted_2 = ["innerHTML"]

import { computed } from 'vue';
import { HtmlString, LinkViewModel } from '@/types/B2CcontentServerContract';
import CMSLinkHandler from '@/shared/content/blocks/helpers/CMSLinkHandler.vue';

export type TextAlignment = 'left' | 'center' | 'right' | 'justify';

interface Props {
    heading?: string;
    title?: string;
    text?: HtmlString|string;
    textClass?: string;
    alignment?: TextAlignment;
    linkUrl?: string;
    linkTarget?: string;
    linkText?: string;
    linkIsSpaLink?: boolean;
    linkStyleAsButton?: boolean;
    linkUnderlineOnHover?: boolean;
    linkShowArrowIcon?: boolean;
    invertTextColor?: boolean;
    alternativeHeadingVariant?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextBlockHandler',
  props: {
    heading: { default: '' },
    title: { default: '' },
    text: { default: '' },
    textClass: { default: '' },
    alignment: { default: undefined },
    linkUrl: { default: '' },
    linkTarget: { default: '_self' },
    linkText: { default: '' },
    linkIsSpaLink: { type: Boolean, default: false },
    linkStyleAsButton: { type: Boolean, default: false },
    linkUnderlineOnHover: { type: Boolean, default: true },
    linkShowArrowIcon: { type: Boolean, default: true },
    invertTextColor: { type: Boolean, default: false },
    alternativeHeadingVariant: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { heading: string, title: string, text: HtmlString|string, textClass: string, alignment: TextAlignment, linkUrl: string, linkTarget: string, linkText: string, linkIsSpaLink: boolean, linkStyleAsButton: boolean, linkUnderlineOnHover: boolean, linkShowArrowIcon: boolean, invertTextColor: boolean, alternativeHeadingVariant: boolean }



const linkBlock = computed<LinkViewModel|undefined>(() => {
    if (!!props.linkUrl && !!props.linkText) {
        return {
            url: props.linkUrl,
            target: props.linkTarget,
            text: props.linkText,
            title: props.linkText,
            spaLink: props.linkIsSpaLink,
        };
    }

    return undefined;
});

const headingVariantClass = computed<string>(() => {
    return props.alternativeHeadingVariant ? 'font-cormorant italic text-17' : 'uppercase';
});

const textAlignmentClass = computed<string>(() => {
    return props.alignment ? `text-${props.alignment}` : '';
});

const textColorClass = computed<string>(() => {
    return props.invertTextColor ? 'text-white' : '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass([_unref(textColorClass), _unref(textAlignmentClass)])
  }, [
    (__props.heading)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["m-0 o-text-caption", [_unref(headingVariantClass)]])
        }, _toDisplayString(__props.heading), 3))
      : _createCommentVNode("", true),
    (__props.title)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    (__props.text)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["mb-x1 heading-spacing", __props.textClass]),
          innerHTML: __props.text
        }, null, 10, _hoisted_2))
      : _createCommentVNode("", true),
    (_unref(linkBlock))
      ? (_openBlock(), _createBlock(CMSLinkHandler, {
          key: 3,
          "link-block": _unref(linkBlock),
          "style-as-button": __props.linkStyleAsButton,
          "show-arrow-icon": __props.linkShowArrowIcon,
          "underline-on-hover": __props.linkUnderlineOnHover
        }, null, 8, ["link-block", "style-as-button", "show-arrow-icon", "underline-on-hover"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})